import { Svg } from './svg'

export const AdminCenterIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00018 8.00012C7.4479 8.00012 7.00018 8.44784 7.00018
      9.00012V11.0001C7.00018 11.5524 7.4479 12.0001 8.00018 12.0001C8.55247 12.0001
      9.00018 11.5524 9.00018 11.0001V9.00012C9.00018 8.44784 8.55247 8.00012 8.00018 8.00012Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.34185 1.44734C8.78906 0.34177 7.21135 0.341772 6.65857 1.44734L4.553 5.65849L2.26947 4.51672C1.20621 3.9851
       -0.0234556 4.84253 0.10782 6.02401L0.907485 13.221C1.02003 14.2339 1.87616 15.0001 2.89525 15.0001H13.1052C14.1243
       15.0001 14.9804 14.2339 15.0929 13.221L15.8926 6.02401C16.0239 4.84253 14.7942 3.9851 13.731 4.51672L11.4474
       5.65849L9.34185 1.44734ZM5.44742 8.34177L8.00021 3.2362L10.553 8.34177L13.8033 6.7166L13.1052 13.0001L2.89525
       13.0001L2.19708 6.7166L5.44742 8.34177Z"
      fill="currentColor"
    />
  </Svg>
)
